import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Apple } from "lucide-react";
import { Link } from "react-router-dom";
const NutritionCounselling = () => {
  return <>
      <section id="nutrition-counselling" className="py-16">
        <div className="container mx-auto px-4">
          <Card className="border-none shadow-lg hover:shadow-xl transition-shadow duration-300 bg-[#b9d5d2]/20">
            <CardHeader className="flex flex-row items-center gap-4">
              <div className="p-4 rounded-full bg-[#b9d5d2]/50">
                <Apple className="w-8 h-8 text-[#167067]" />
              </div>
              <h2 className="text-xl font-semibold text-primary leading-none tracking-tight">
                Nutrition Counselling
              </h2>
            </CardHeader>
            <CardContent>
              <div className="space-y-6">
                <p className="text-gray-600 leading-relaxed">
                  One-on-one sessions and group counselling sessions are both available. Different counselling approaches are chosen that best fits your needs.
                </p>
                
                <h3 className="text-lg font-semibold text-primary mt-8">Our Approach</h3>
                <p className="text-gray-600 leading-relaxed">At Functional Foodie, we believe that nutrition counselling should be personalised and evidence-based. Our registered dietitians work closely with you to understand your unique needs, preferences, and health goals.</p>
                
                <h3 className="text-lg font-semibold text-primary">What to Expect</h3>
                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                  <li>Comprehensive nutrition assessment</li>
                  <li>Personalised meal planning</li>
                  <li>Actionable dietary recommendations</li>
                  <li>Ongoing support and follow-up sessions</li>
                  <li>Evidence-based nutrition education</li>
                </ul>
                
                <h3 className="text-lg font-semibold text-primary">Who Can Benefit</h3>
                <p className="text-gray-600 leading-relaxed">Our nutrition counselling services are ideal for individuals looking to improve their overall health, manage chronic conditions, optimise athletic performance, or simply develop healthier eating habits.</p>
                
                <div className="mt-8 flex justify-center">
                  <Link to="/booking">
                    <Button size="lg" className="bg-primary hover:bg-primary-light text-white px-8">
                      Book a Consultation
                    </Button>
                  </Link>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </>;
};
export default NutritionCounselling;